/**
 * Pages-level re-export of HOTNEWS i18n catalog from src/i18n/hotnews.ts
 *
 * Pages app cannot import from `../../../src/i18n/hotnews` directly because
 * the path lies outside Vite's source root and module resolution. Instead,
 * we duplicate the lightweight resolver shape locally + re-export the
 * full catalog (deep-copy frozen) so any drift fails fast at typecheck.
 *
 * Source-of-truth contract: matches `HotNewsCopy` shape from
 * /Users/ngocdang/Claude-source/co-law/src/i18n/hotnews.ts (same key set).
 */

import {
  HOTNEWS_VI as CORE_HOTNEWS_VI,
  HOTNEWS_EN as CORE_HOTNEWS_EN,
  HOTNEWS_TAG_COLOR_TOKENS as CORE_TOKENS,
} from '@core/i18n-hotnews-shim';
import type { Lang } from '../use-lang';

export const HOTNEWS_VI = CORE_HOTNEWS_VI;
export const HOTNEWS_EN = CORE_HOTNEWS_EN;
export const HOTNEWS_TAG_COLOR_TOKENS = CORE_TOKENS;

export type HotNewsCopy = typeof CORE_HOTNEWS_VI;

export function resolveHotNews(lang: Lang): HotNewsCopy {
  if (lang === 'vi') return CORE_HOTNEWS_VI;
  // Coerce: EN catalog has same keys; VN_ONLY sentinel becomes VN fallback.
  const out: Record<string, string> = {};
  const en = CORE_HOTNEWS_EN as Record<string, string>;
  const vi = CORE_HOTNEWS_VI as Record<string, string>;
  for (const k of Object.keys(vi)) {
    const enValue = en[k];
    out[k] = !enValue ? vi[k]! : enValue;
  }
  return out as unknown as HotNewsCopy;
}

export type PlayfulTag = keyof typeof CORE_TOKENS;
